import { readSubscription } from '@hub/lib/subscription/readSubscription';
import type { RouterContext } from '@hub/router';
import { redirect } from '@hub/router/domain-routes';
import { authUser } from '@hub/router/routerAuth';
import { hasDunningLock } from './dunning';
import { getExternalBilling } from './externalBilling';
import { BillingPaths } from './route.paths';

/**
 * Blocks the payment-edit URL itself, not just the button, so a deep link or a restored tab cannot
 * land on a form that changes payment data waipu does not hold.
 *
 * Fails open by design: the gate only hides a useless form, so a subscription outage, schema drift
 * or a dunning lock all let the navigation through. Dunning-locked customers are confined to the
 * payment read/edit pair, and redirecting them off the form would leave them no action at all.
 */
export async function redirectWhenExternallyBilled({ context }: { context: RouterContext }) {
  if (hasDunningLock(authUser(context.auth)?.flags)) {
    return;
  }

  const subscription = await readSubscription(context.queryClient);
  if (getExternalBilling(subscription?.billedBy)) {
    throw redirect({ to: BillingPaths.payment.path, replace: true });
  }
}
